<section class="pt-3 overflow-y-auto scrollable-content" [ngClass]="{'h-auto max-h-[calc(100vh-380px)]': !loadingAvailabilities}">
    @if (availabilities) {
        @for (data of availabilitiesArray; let first = $first, last = $last; track $index) {
            @if (showedDate === moment(data.date).format('DD/MM/YYYY') && data.type === 'success') {
                <article class="p-4 mb-4 mx-1 rounded flex flex-col gap-4 cursor-pointer"
                    [ngClass]="{'border-2 border-primary-purple-light!': checkAvailabilitySelected(data.availability), $index, 'mt-4': !first, 'mt-1': first}"
                    (click)="!isTripInformative(data.availability) && selectAvailability(data.availability)"
                    [tooltip]="isTripInformative(data.availability) ? literalService.get('bookings.bookingNotAvailable', true) : ''"
                    [position]="isTripInformative(data.availability) ? TooltipPosition.DYNAMIC : undefined"
                    [visibleTooltip]="isTripInformative(data.availability)"
                    >
                    @if (hasRestrictionWarnings(data.availability)) {
                        <div class="flex justify-between items-center align-middle">
                            <div class="bg-secondary-yellow-02 p-1 rounded w-fit">
                                <label class="font-semibold text-base cursor-pointer">{{ literalService.get('bookings.restrictions.cardTitle', true) }}</label>
                            </div>
                            <img [src]="images.info" class="h-6 w-6 filter-neutrals-grey-04" alt="info" [tooltip]="restrictionWarningsMessage(data.availability)" [position]="TooltipPosition.DYNAMIC"/>
                        </div>
                    }
                    <ng-container *ngTemplateOutlet="availabilityCard; context: { $implicit: data.availability, failed: false }" />
                </article>
            } @else if (showedDate === moment(data.date).format('DD/MM/YYYY') && data.type === 'failure') {
                @if (data.availability.length === 1 && data.availability[0].failureReason === 'NoAvailabilitiesFound') {
                    <div class="flex justify-center">
                        <img [src]="images.booking.noOptions" class="h-48 w-48" />
                    </div>
                    <div class="text-center">
                        <h4 class="font-bold text-xl text-neutrals-grey-04">{{ literalService.get('bookings.noResults', true) }}</h4>
                        <label class="flex font-normal text-base mr-12 ml-12 mb-3 mt-2 text-neutrals-grey-04">{{ literalService.get('bookings.noResultsExplanation', true) }}</label>
                    </div>
                } @else {
                    @if (isFirstInSpecificDate($index, data.date)) {
                        <h2 class="font-semibold text-xl mt-4 mb-2">{{ literalService.get('bookings.notAvailable', true) }}</h2>
                    }
                    @let firstLeg = data.availability[0];
                    <article class="p-4 mx-1 mb-4 rounded flex flex-col gap-4" [ngClass]="{'border-2 border-secondary-red': firstLeg.failureReason}">
                        <div class="flex justify-between items-center align-middle">
                            <div class="bg-secondary-red/20 p-1 rounded w-fit">
                                <label class="font-semibold text-base">{{ literalService.get('bookings.' + firstLeg.failureReason, true) }}</label>
                            </div>
                            <img [src]="images.info" class="h-6 w-6 filter-neutrals-grey-04" alt="info" [tooltip]="literalService.get('bookings.' + firstLeg.failureReason + 'Text', true)" [position]="TooltipPosition.DYNAMIC"/>
                        </div>
                        <ng-container *ngTemplateOutlet="availabilityCard; context: { $implicit: data.availability, failed: true }" />
                    </article>
                }
            }
        }
    }
</section>

@if (hasSuccessAvailabilities()) {
    <div class="flex items-center mt-3 mb-3">
        <img [src]="images.booking.notifications" class="h-5 w-5 mr-1" alt="notifications" />
        <label class="text-base font-normal flex-1 ml-1">{{ literalService.get('bookings.actions.deleteBooking.notify', true) }}</label>
        <app-toggle [checked]="!!newBooking.sendNotification" (change)="sendNotificationChange.emit($any($event.target).checked)"></app-toggle>
    </div>
    @if (!allAvailabilitiesSelected) {
        <div class="flex flex-row items-center gap-2">
            <div class="flex justify-center w-full">
                <input type="button" class="secondary text-white gap-4 border-2 font-semibold h-12 w-full uppercase cursor-pointer" (click)="multipleBooking()" [value]="literalService.get('bookings.automaticSelection')" />
            </div>
            <div class="flex justify-end items-center">
                <img [src]="images.info" class="h-6 w-6" [tooltip]="literalService.get('bookings.infoAvailabilitiesActions', true)" [position]="TooltipPosition.DYNAMIC" />
            </div>
        </div>
    }
    @if (allAvailabilitiesSelected) {
        <div class="flex justify-center mt-4">
            <input type="button" class="primary text-white gap-4 border-2 font-semibold h-12 w-full mr-2 uppercase cursor-pointer" (click)="makeBooking()" [value]="literalService.get(newBooking.multipleDates ? 'bookings.makeBookings' : 'bookings.makeBooking')" />
        </div>
    }
}

<ng-template #availabilityCard let-trip let-failed="failed">
    @let firstLeg = trip[0];
    @let lastLeg = trip[trip.length - 1];
    <div class="flex gap-2">
        <div class="flex flex-col items-center w-5 py-1 self-stretch">
            <div class="flex h-7 items-center">
                <div class="flex h-5 w-5 rounded-[50%] justify-center items-center bg-primary-purple-light">
                    <div class="h-2.5 w-2.5 rounded-[50%] bg-white"></div>
                </div>
            </div>
            <div class="flex gradient w-1 flex-1 -my-2"></div>
            <div class="flex h-7 items-center">
                <div class="flex h-5 w-5 rounded-[50%] justify-center items-center bg-primary-green">
                    <div class="h-2.5 w-2.5 rounded-[50%] bg-white"></div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-col gap-4 py-1 justify-start overflow-hidden">
            <div class="w-full min-h-7 flex items-center justify-between">
                <div class="w-[80%] flex gap-1">
                    @if (originName(firstLeg); as originName) {
                        <label [id]="`availability-start-${firstLeg.id}`" class="font-semibold text-base cursor-pointer line-clamp-2 leading-5 text-ellipsis" [tooltip]="utilsService.visibleTooltip(`availability-start-${firstLeg.id}`) ? originName : ''" [visibleTooltip]="utilsService.visibleTooltip(`availability-start-${firstLeg.id}`)" [position]="TooltipPosition.ABOVE">
                            {{ originName }}
                        </label>
                    }
                </div>
                <div class="cursor-pointer">
                    @if (failed) {
                        @if (firstLeg.inStop.dateTime) {
                            <span class="font-bold text-xl" [tooltip]="getVariabilityText(firstLeg.inStop)" [position]="TooltipPosition.DYNAMIC">
                                {{ moment(firstLeg.inStop.dateTime).format('HH:mm') }}
                            </span>
                        }
                    } @else {
                        <span class="font-bold text-xl" [tooltip]="getVariabilityText(firstLeg.inStop)" [position]="TooltipPosition.DYNAMIC" [visibleTooltip]="!firstLeg.informative">
                            {{ bookingsService.availabilityDepartureTime(firstLeg) }} {{!firstLeg.informative ? ' *' : ''}}
                        </span>
                    }
                </div>
            </div>
            @if (!failed || hasServicesToShow(trip)) {
                <div class="w-full flex justify-between items-center">
                    <div class="flex gap-1 items-center" [ngClass]="failed ? '' : (showAvailabilityDetail(trip) ? 'flex-wrap' : 'flex-row')">
                        @if (firstLeg.walkingPickup; as walkingPickup) {
                            <div class="flex gap-0.5 items-center shrink-0" [tooltip]="bookingsService.walkingText(walkingPickup)" [position]="TooltipPosition.DYNAMIC">
                                <img [src]="images.booking.pedestrian" class="h-4 w-4" alt="pedestrian" />
                                <label class="font-semibold text-sm cursor-pointer">{{ bookingsService.walkingMinutes(walkingPickup) }}</label>
                            </div>
                            <img [src]="images.next" alt="next" class="h-3 w-3 shrink-0" />
                        }
                        @for (leg of trip; let legLast = $last; track leg.id) {
                            @if (leg.serviceInfo) {
                                <img [src]="images.busPrivate" alt="bus private" class="h-5 w-5" />
                                <app-service-tag [serviceInfo]="leg.serviceInfo"></app-service-tag>
                                @if (hasAlterations(leg.serviceInfo.id!) && leg.alternative) {
                                    <div class="rounded-full px-2 alteration-shadow bg-secondary-yellow-02 shrink-0 h-6 flex items-center">
                                        <img [src]="images.alert" alt="alterationWarning" class="h-5 w-5 filter-secondary-orange-02" [tooltip]="getAlterationMessageByService(leg.serviceInfo.id!)" [position]="TooltipPosition.DYNAMIC" />
                                    </div>
                                }
                                @if (!failed && leg.expeditionId && activeTicketsByExpedition[leg.expeditionId]?.length) {
                                    <app-active-tickets-chip class="shrink-0" [tickets]="activeTicketsByExpedition[leg.expeditionId]" [compact]="true" [openInNewTab]="true" />
                                }
                                @if (!legLast) {
                                    <img [src]="images.next" alt="next" class="h-3 w-3 shrink-0" />
                                }
                            }
                        }
                        @if (lastLeg.walkingDropoff; as walkingDropoff) {
                            <img [src]="images.next" alt="next" class="h-3 w-3 shrink-0" />
                            <div class="flex gap-0.5 items-center shrink-0" [tooltip]="bookingsService.walkingText(walkingDropoff)" [position]="TooltipPosition.DYNAMIC">
                                <img [src]="images.booking.pedestrian" class="h-4 w-4" alt="pedestrian" />
                                <label class="font-semibold text-sm cursor-pointer">{{ bookingsService.walkingMinutes(walkingDropoff) }}</label>
                            </div>
                        }
                        @if (trip.length === 1 && !firstLeg.walkingPickup && !firstLeg.walkingDropoff && firstLeg.serviceInfo?.name) {
                            <label class="flex-1 min-w-0 truncate font-bold text-base cursor-pointer" [tooltip]="firstLeg.serviceInfo.name" [position]="TooltipPosition.DYNAMIC">{{ firstLeg.serviceInfo.name }}</label>
                        }
                    </div>
                    @if (!failed) {
                        <div class="flex items-center gap-1">
                            <img [hidden]="!hasEcoRoute(trip)" [src]="images.booking.eco" alt="eco" class="h-6 w-6 filter-primary-green" [tooltip]="literalService.get('bookings.ecoRoute', true)" [position]="TooltipPosition.DYNAMIC" />
                        </div>
                    }
                </div>
            }
            @if (!failed) {
                @let alternativeLeg = getAlternativeLeg(trip);
                @if (alternativeLeg) {
                    <div class="alternative-badge w-fit rounded-lg px-3 py-1.5" [tooltip]="getAlternativeMessage(alternativeLeg.serviceInfo.id!)" [position]="TooltipPosition.DYNAMIC">
                        <label class="text-primary-purple-light font-semibold text-sm cursor-pointer">{{ literalService.get('bookings.alternative.includesAlternatives', true) }}</label>
                    </div>
                }
            }
            <div class="w-full min-h-7 flex flex-row items-center justify-between">
                <div class="w-[80%] flex gap-1 overflow-hidden">
                    @if (destinationName(lastLeg); as destinationName) {
                        <label [id]="`availability-end-${lastLeg.id}`" class="font-semibold text-base cursor-pointer text-left line-clamp-2 leading-5 text-ellipsis" [tooltip]="utilsService.visibleTooltip(`availability-end-${lastLeg.id}`) ? destinationName : ''" [visibleTooltip]="utilsService.visibleTooltip(`availability-end-${lastLeg.id}`)" [position]="TooltipPosition.BELOW">
                            {{ destinationName }}
                        </label>
                    }
                </div>
                <div class="cursor-pointer">
                    @if (failed) {
                        @if (lastLeg.outStop.dateTime) {
                            <span class="font-bold text-xl" [tooltip]="getVariabilityText(lastLeg.outStop)" [position]="TooltipPosition.DYNAMIC">
                                {{ moment(lastLeg.outStop.dateTime).format('HH:mm') }}
                            </span>
                        }
                    } @else {
                        <span class="font-bold text-xl" [tooltip]="getVariabilityText(lastLeg.outStop)" [position]="TooltipPosition.DYNAMIC" [visibleTooltip]="!lastLeg.informative">
                            {{ bookingsService.availabilityArrivalTime(lastLeg) }} {{!lastLeg.informative ? ' *' : ''}}
                        </span>
                    }
                </div>
            </div>
        </div>
    </div>
    @let tripUrl = failed ? null : expeditionUrl(trip);
    @if (!hasSeveralLegs(trip) && (lastLeg.vehiclePlate || lastLeg.tripTime || lastLeg.tripPassengers || lastLeg.driverName || tripUrl)) {
        <div class="flex items-center justify-between gap-2">
            <div class="flex flex-col gap-4">
                @if (lastLeg.vehiclePlate || lastLeg.tripTime || lastLeg.tripPassengers) {
                    <div class="flex items-center gap-2">
                        @if (lastLeg.vehiclePlate || lastLeg.tripTime) {
                            <div class="flex items-center gap-2">
                                <img [src]="images.busCar" class="h-5 w-5 " />
                                <label class="font-normal text-sm cursor-pointer">{{ lastLeg.vehiclePlate }}
                                    @if (lastLeg.tripTime) {
                                        <span>({{ literalService.get('bookings.departure', true)}} {{ moment(lastLeg.tripTime, [moment.ISO_8601, 'HH:mm']).format('HH:mm') }})</span>
                                    }
                                </label>
                            </div>
                        }
                        @if (lastLeg.tripPassengers) {
                            <div class="flex items-center gap-2">
                                <img [src]="images.booking.passengers" class="h-5 w-5" />
                                <label class="font-normal text-sm cursor-pointer">{{ lastLeg.tripPassengers }}</label>
                            </div>
                        }
                    </div>
                }
                @if (lastLeg.driverName) {
                    <div class="flex items-center gap-2">
                        <img [src]="images.booking.driver" class="h-5 w-5" />
                        <label class="font-normal text-sm cursor-pointer">{{ lastLeg.driverName }}</label>
                    </div>
                }
            </div>
            @if (tripUrl) {
                <a [href]="tripUrl" target="_blank" rel="noopener" class="shrink-0" (click)="utilsService.openInNewTab($event, tripUrl)" [tooltip]="literalService.get('availabilities.goToTrip', true)" [position]="TooltipPosition.ABOVE">
                    <img [src]="images.availabilities.trip" alt="trip" draggable="false" class="h-7 w-7 cursor-pointer" />
                </a>
            }
        </div>
    }
    @if (hasSeveralLegs(trip)) {
        @for (leg of trip; track leg.id) {
            @if (leg.tripTime || leg.tripPassengers) {
                <div class="flex items-center gap-2">
                    @if (leg.serviceInfo) {
                        <app-service-tag [serviceInfo]="leg.serviceInfo"></app-service-tag>
                    }
                    @if (leg.tripTime) {
                        <div class="flex items-center gap-2">
                            <img [src]="images.busCar" class="h-5 w-5" />
                            <label class="font-normal text-sm cursor-pointer">{{ literalService.get('bookings.departure', true) }} {{ moment(leg.tripTime, [moment.ISO_8601, 'HH:mm']).format('HH:mm') }}</label>
                        </div>
                    }
                    @if (leg.tripPassengers) {
                        <div class="flex items-center gap-2">
                            <img [src]="images.booking.passengers" class="h-5 w-5" />
                            <label class="font-normal text-sm cursor-pointer">{{ leg.tripPassengers }}</label>
                        </div>
                    }
                </div>
            }
        }
    }
</ng-template>
